import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    sidebarNarrow: false,
    asideShow: false,
    sidebarUnfoldable: false,
    theme: 'default',
    detailsPage: {
        name: '',
        pageName: '', // The name of the route to avoid false naming for unimplemented routes
    },
    company: {},
    appVersion: '',
};

export const viewSlice = createSlice({
    name: 'view',
    initialState,
    reducers: {
        setView: (state, action) => ({
            ...state,
            ...action.payload,
        }),
        setCurrentDetailsPage: (state, action) => ({
            ...state,
            detailsPage: action.payload,
        }),
        setCompany: (state, action) => ({
            ...state,
            company: action.payload,
        }),
        setAppVersion: (state, action) => ({
            ...state,
            appVersion: action.payload,
        }),
    },
});

export const { setView, setCurrentDetailsPage, setCompany, setAppVersion } = viewSlice.actions;

export default viewSlice.reducer;
